import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MonthlyReportUIHelpers";

const MonthlyReportUIContext = createContext();

export function useMonthlyReportUIContext() {
  return useContext(MonthlyReportUIContext);
}

export const MonthlyReportUIConsumer = MonthlyReportUIContext.Consumer;

export function MonthlyReportUIProvider({ monthlyReportParameters, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    term: monthlyReportParameters.term,
    date: monthlyReportParameters.date,
    dateEnd: monthlyReportParameters.dateEnd,
    sectionId: monthlyReportParameters.sectionId,
    studentId: monthlyReportParameters.studentId
  };

  return (
    <MonthlyReportUIContext.Provider value={value}>
      {children}
    </MonthlyReportUIContext.Provider>
  );
}